import http from './http'

// 获取列表
export function pageList (data) {
  return http.get('/user/help/comment', { params: data })
}

// 获取详情
export function getDetail (id) {
  return http.get(`/user/article/${id}`)
}

// 添加
export function add (data) {
  return http.post('/user/article', data)
}

// 编辑
export function edit (data) {
  return http.put(`/user/help/comment/${data.Id}`, data)
}

// 删除
export function remove (id) {
  return http.delete(`/user/help/comment/${id}`)
}

// 获取话题列表
export function getCategoryList () {
  return http.get('/web/article/category/tree/0')
}
